export const apiKey = '22b9ae4df023b2ad97c1baea7b0741e2';
export const subDomain = 'achievece';
export const contentType = 'application/json';



// WEBPACK FOOTER //
// ./src/ThinkificConfig.js